import { render, staticRenderFns } from "./ChoiceTypeAutoComplete.vue?vue&type=template&id=0b0216ea&scoped=true"
import script from "./ChoiceTypeAutoComplete.vue?vue&type=script&lang=ts"
export * from "./ChoiceTypeAutoComplete.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0216ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Intersect from 'vuetify/lib/directives/intersect'
installDirectives(component, {Intersect})
